import {Observable} from 'rxjs';
import {Injectable, inject} from '@angular/core';
import {HttpShortHeaders, IVersionResponse} from '@core/api/data-access';
import {StorageKeys} from '@core/storage';
import {storageSignal, StorageSignal} from '@shared/signals-extension';
import {config} from '../../../assets/config';
import {ApiService} from '@core/api/data-access';

@Injectable({
	providedIn: 'root',
})
export class VersionService {
	public readonly apiService: ApiService = inject(ApiService);
	/* -------------------------------------------------------------------------------------------------------------- */

	readonly swVersion$: StorageSignal<string> = storageSignal(StorageKeys.GlobalKeys.SW_VERSION, config.version);

	constructor() {}

	public getVersion(): Observable<IVersionResponse> {
		const headers: HttpShortHeaders = {
			accept: '*/*',
		};
		return this.apiService.get<IVersionResponse>('cron/version', undefined, headers, false);
	}

	public getLocalFrontendVersion(): string {
		return config.version;
	}
}
